module.exports = __webpack_public_path__ + "static/img/215.f336549.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/200921/215.jpg
// module id = /Gmo
// module chunks = 0